"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationsReportHeader = void 0;
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const connect_asset_1 = require("shared/connect-asset");
require("./certifications-report-header.less");
let CertificationsReportHeader = class CertificationsReportHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.completionStatuses = [
            {
                id: 0,
                label: "All Completion Statuses",
                value: "allcompletion"
            },
            {
                id: 1,
                label: "Approved",
                value: "approved"
            },
            {
                id: 2,
                label: "Rejected",
                value: "rejected"
            },
            {
                id: 3,
                label: "Unapproved",
                value: "unapproved"
            }
        ].sort((a, b) => (a.label > b.label ? 1 : -1));
        this.expStatuses = [
            {
                id: 0,
                label: "All Expiration Statuses",
                value: "allexp"
            },
            {
                id: 3,
                label: "Compliant",
                value: "compliant"
            },
            {
                id: 4,
                label: "Expiring",
                value: "expiring"
            },
            {
                id: 5,
                label: "Overdue",
                value: "overdue"
            },
            {
                id: 6,
                label: "No Exp Date",
                value: "noexp"
            }
        ].sort((a, b) => (a.label > b.label ? 1 : -1));
        this.entities = [
            {
                id: 0,
                label: "All Entities",
                value: connect_asset_1.EntityType.all
            },
            {
                id: 1,
                label: "Provider",
                value: connect_asset_1.EntityType.provider
            },
            {
                id: 2,
                label: "User",
                value: connect_asset_1.EntityType.user
            },
            {
                id: 3,
                label: "Pharmacy",
                value: connect_asset_1.EntityType.site
            }
        ].sort((a, b) => (a.label > b.label ? 1 : -1));
        this.filterText = "";
        this.siteId = 0;
        this.completionStatus = "allcompletion";
        this.expStatus = "allexp";
        this.entity = connect_asset_1.EntityType.all;
        this.searchType = "";
        this.requiredAsset = 0;
        this.headerToggle = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
        this.handleLoader = () => {
            store_1.reportsStore.showLoader = !store_1.reportsStore.showLoader;
        };
        this.handleChangeSearchType = (searchType) => {
            this.searchType = searchType;
            this.siteId = 0;
            this.completionStatus = "allcompletion";
            this.expStatus = "allexp";
            this.entity = connect_asset_1.EntityType.all;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleChangeCompletionStatus = (value) => {
            this.completionStatus = value;
        };
        this.handleChangeExpStatus = (value) => {
            this.expStatus = value;
        };
        this.handleChangeEntity = (value) => {
            this.entity = value;
        };
        this.handleChangeRequiredAssets = (id) => {
            this.requiredAsset = Number(id);
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            await store_1.reportsStore.loadCertificationsReport(this.searchType, this.siteId, this.entity, this.completionStatus, this.expStatus, this.requiredAsset, true);
        };
        this.handleCancel = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
    }
    get availableSearchTypes() {
        return [
            {
                id: 1,
                label: "Uploaded Assets",
                value: "uploaded"
            },
            {
                id: 2,
                label: "Missing Required Assets",
                value: "missing"
            }
        ];
    }
    componentWillMount() {
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.siteId = store_3.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            store_2.sitesListStore.loadSitesNoRelation();
        }
        store_1.reportsStore.loadRequiredAssets();
    }
    get requiredAssets() {
        const options = [];
        if (store_1.reportsStore.requiredAssets) {
            if (this.entity !== connect_asset_1.EntityType.all) {
                const filtered = store_1.reportsStore.requiredAssets.filter(asset => asset.entityType === this.entity);
                options.push({ id: 0, label: "All Required Assets", value: "0" });
                filtered.forEach((asset, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: asset.categoryName,
                        value: asset.id.toString()
                    });
                });
            }
            else {
                options.push({ id: 0, label: "All Required Assets", value: "0" });
                store_1.reportsStore.requiredAssets.forEach((asset, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: `${asset.categoryName} (${asset.entityType})`,
                        value: asset.id.toString()
                    });
                });
            }
        }
        return options;
    }
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    render() {
        const { label = "Search", title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options")),
            store_1.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, top: "25%", width: "25%", overflowY: true, buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", { className: "" },
                        React.createElement(select_1.MaterialSelect, { options: this.availableSearchTypes, required: true, label: "Search Type", onSelect: this.handleChangeSearchType, value: this.searchType, width: "100%" }),
                        React.createElement("br", null),
                        this.searchType === "uploaded" ||
                            this.searchType === "missing" ? (React.createElement(React.Fragment, null,
                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "", width: "100%" }),
                            React.createElement("br", null),
                            React.createElement(select_1.MaterialSelect, { options: this.entities, required: true, searchable: true, label: "Entity Type", onSelect: this.handleChangeEntity, value: String(this.entity) || "", width: "100%" }),
                            React.createElement("br", null))) : null,
                        this.searchType === "uploaded" ? (React.createElement(React.Fragment, null,
                            React.createElement(select_1.MaterialSelect, { options: this.completionStatuses, required: true, searchable: true, label: "Completion Status", onSelect: this.handleChangeCompletionStatus, value: String(this.completionStatus) || "", width: "100%" }),
                            React.createElement("br", null),
                            React.createElement(select_1.MaterialSelect, { options: this.expStatuses, required: true, searchable: true, label: "Expiration Status", onSelect: this.handleChangeExpStatus, value: String(this.expStatus) || "", width: "100%" }),
                            React.createElement("br", null))) : null,
                        this.searchType === "missing" ? (React.createElement(React.Fragment, null,
                            React.createElement(select_1.MaterialSelect, { options: this.requiredAssets, required: true, searchable: true, label: "Required Assets", onSelect: this.handleChangeRequiredAssets, value: String(this.requiredAsset) || "", width: "100%" }),
                            React.createElement("br", null))) : null)))) : null,
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.computed
], CertificationsReportHeader.prototype, "availableSearchTypes", null);
__decorate([
    mobx_1.observable
], CertificationsReportHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], CertificationsReportHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], CertificationsReportHeader.prototype, "completionStatus", void 0);
__decorate([
    mobx_1.observable
], CertificationsReportHeader.prototype, "expStatus", void 0);
__decorate([
    mobx_1.observable
], CertificationsReportHeader.prototype, "entity", void 0);
__decorate([
    mobx_1.observable
], CertificationsReportHeader.prototype, "searchType", void 0);
__decorate([
    mobx_1.observable
], CertificationsReportHeader.prototype, "requiredAsset", void 0);
__decorate([
    mobx_1.computed
], CertificationsReportHeader.prototype, "requiredAssets", null);
__decorate([
    mobx_1.computed
], CertificationsReportHeader.prototype, "availableOptions", null);
CertificationsReportHeader = __decorate([
    mobx_react_1.observer
], CertificationsReportHeader);
exports.CertificationsReportHeader = CertificationsReportHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/certifications-report/components/certifications-report-header/certifications-report-header.tsx
// module id = 3933
// module chunks = 0